import React, {Component} from 'react';

class Music extends Component {
  render() {
    return (
      <div className="App-body-project">
        <div className="App-body-music">
          <h2>music bio</h2>
          <p>Meredith Young-Ng, violin, began playing the violin at age five.
            She currently studies with Jolán Friedhoff. With a love for chamber
            music, Meredith has had the opportunity to spend a quarter in UC
            Davis's Chamber Music Program, a year in Brown's Chamber Music
            Program, 3 summers at the San Francisco Conservatory Summer Music
            West program, 2 summers at California Summer Music, and 1 summer at
            the Peninsula Youth Symphony Chamber Music program. Meredith also
            has ample orchestral experience as a previous member of the Palo
            Alto Chamber Orchestra, Monta Vista High School Chamber Orchestra,
            California Youth Symphony, and Cornell Symphony Orchestra. She had
            the honor of performing as the co-concertmaster of the CYS
            Associate Orchestra in 2013-2014. Her primary teachers have been
            Debra Fong, Katherine Winterstein, Eleanor Angel, and Ariana Kim.
            Meredith has also studied piano for 13 years, most recently
            with Nancy Jensen, receiving Branch Honors and a Senior Medallion in
            the MTAC Certificate of Merit program. When not making music in her
            free time, Meredith can be found hacking away on her research as a
            Ph.D. student at UC Davis studying computer science.<br /><br />
            Listen to one of Meredith's latest performances below:
          </p>
          <div className="App-body-project-video">
            <iframe title="Moszkowski Trio"
            src="https://www.youtube.com/embed/h-kTBedzvtk" frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Music;
